/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_New_Group_ButtonInputs */



/**
* | output |
* | --- |
* | "New Group" |
*
* @param {Team_Manager_New_Group_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_new_group_button = /** @type {((inputs?: Team_Manager_New_Group_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_New_Group_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Gruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новая группа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新集团")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo Grupo")
	return /** @type {LocalizedString} */ ("New Group")
});